/* eslint-disable jsx-a11y/anchor-is-valid */

import i18next from "i18next";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import vn8 from "../../assets/images/flag/vn8.png";
import en8 from "../../assets/images/flag/eng8.png";
import { changeLanguage } from "../../redux/language/reducer";
import logo_gopaperless from "../../assets/images/logos/paperless/gopaperless-logo-darkblue.png";
import { Link } from "react-router-dom";

const NavbarTop = () => {
  const { t, i18n } = useTranslation();

  // useEffect(() => {
  //   if (i18n.language?.length > 2) {
  //     i18next.changeLanguage("en");
  //   }
  // }, []);


  const a = document.getElementById("root").offsetWidth;

  const [open, setOpen] = useState(false);
  function handeleButton() {
    if (open === false) {
      document.getElementById("handle").classList.add("fs-navigation-open");
      document
        .querySelector('[data-navigation-handle="#handle"]')
        .classList.add("fs-navigation-open");
      document.getElementById("content").classList.add("fs-navigation-open");
      document.getElementById("logo").style.display = "none";
      document.getElementById("brand").style.height = "80px";
      document.getElementById("handle").style.paddingTop = "46px";
      setOpen(true);
    } else {
      document.getElementById("handle").classList.remove("fs-navigation-open");
      document
        .querySelector('[data-navigation-handle="#handle"]')
        .classList.remove("fs-navigation-open");
      document.getElementById("content").classList.remove("fs-navigation-open");
      document.getElementById("logo").style.display = "flex";
      // document.getElementById('brand').style.height = '0';
      // document.getElementById('handle').style.paddingTop = '40px';
      setOpen(false);
    }
  }

  window.addEventListener("click", function click(e) {
    if (
      !e.target.matches("#menuReponsiveLeft") &&
      !e.target.matches("#handle")
    ) {
      document
        .querySelector('[data-navigation-handle="#handle"]')
        .classList.remove("fs-navigation-open");
      document.getElementById("handle").classList.remove("fs-navigation-open");
      document.getElementById("content").classList.remove("fs-navigation-open");
      document.getElementById("logo").style.display = "flex";
      // document.getElementById('brand').style.height = '0';
      // document.getElementById('handle').style.paddingTop = '40px';
      setOpen(false);
    }
  });

  const handleOpenHowItWork = () => {
    document.getElementById("openCompany").classList.remove("open");
    // document.getElementById("resource").classList.remove("open");
    document.getElementById("openHowItWorks").classList.toggle("open");
  };

  const handleOpenCompany = () => {
    document.getElementById("openHowItWorks").classList.remove("open");
    // document.getElementById("resource").classList.remove("open");
    document.getElementById("openCompany").classList.toggle("open");
  };

  const handleOpenResource = () => {
    document.getElementById("openHowItWorks").classList.remove("open");
    document.getElementById("openCompany").classList.remove("open");
    // document.getElementById("resource").classList.toggle("open");
  };

  // const handleOpenLanguage = () => {
  //     document.getElementById("openHowItWorks").classList.remove("open")
  //     document.getElementById("openCompany").classList.remove("open")
  //     document.getElementById("openLanguage").classList.toggle("open")
  // }

  window.addEventListener("click", function click(e) {
    if (!e.target.matches("#how_it_works")) {
      document.getElementById("openHowItWorks").classList.remove("open");
    }
    if (!e.target.matches("#company")) {
      document.getElementById("openCompany").classList.remove("open");
    }
    // if (!e.target.matches("#resource")) {
    //   document.getElementById("resource").classList.remove("open");
    // }
    // if (!e.target.closest("#language")) {
    //     document.getElementById("openLanguage").classList.remove("open")
    // }
  });

  useEffect(() => {
    if (document.getElementById("root").offsetWidth > 974) {
      document
        .getElementById("handle")
        .classList.remove("fs-navigation-enabled", "fs-navigation-open");
      // element.classList.remove("fs-navigation-open")
      document.getElementById("content").classList.remove("fs-navigation-open");
    } else {
      document.getElementById("handle").classList.add("fs-navigation-enabled");
    }
  }, [a]);

  window.addEventListener("resize", function (e) {
    document.getElementById("openHowItWorks").classList.remove("open");
    // document.getElementById("resource").classList.remove("open");
    document.getElementById("openCompany").classList.remove("open");

    // document.getElementById("openLanguage").classList.remove("open")
    if (this.window.innerWidth > 991.9) {
      document
        .getElementById("handle")
        .classList.remove("fs-navigation-enabled", "fs-navigation-open");
      // element.classList.remove("fs-navigation-open")
      document.getElementById("content").classList.remove("fs-navigation-open");
      document
        .getElementById("menuReponsiveLeft")
        .classList.remove("fs-navigation-open");
      document.getElementById("logo").style.display = "flex";
      // document.getElementById('brand').style.height = '0';
      // document.getElementById('handle').style.paddingTop = '40px';
    } else {
      document.getElementById("handle").classList.add("fs-navigation-enabled");
    }
  });
    const handleOpenMenuBottom = (e) => {
    e.preventDefault();
    document.getElementById("openHowItWorks")?.classList.remove("open");
    document.getElementById("openCompany")?.classList.remove("open");
    document.getElementById("openDropupMenuBottom").classList.toggle("open");
  };
      const handleChangeLanguage = (language) => {
    const newPath = window.location.pathname.replace(
      /^\/(en|vi)/,
      `/${language}`,
    );
    window.location.href = `${newPath}${window.location.search}${window.location.hash}`;
  };
  return (
    <nav className="navbar top gray-bg navbar-fixed-top">
       <style>{`
        #dropupMenuBottom,
        #dropupMenuBottom:focus,
        #dropupMenuBottom:active,
        #dropupMenuBottom:focus-visible,
        #dropupMenuBottom:hover {
          outline: none;
          box-shadow: none;
          border: none;
        }
      `}</style>
      <div className="container px-md-0">
        <div className="navbar-header">
          <div className="navbar-brand" id="brand">
            <Link
              to="/"
              id="logo"
              alt="Mobile-ID - GoPaperless Service"
              title="Quatera - GoPaperless Service"
            >
              <img
                className="img-responsive"
                alt="GoPaperless"
                data-no-retina
                src={logo_gopaperless}
              />
            </Link>
          </div>
          <div
            id="handle"
            className="fs-navigation-handle fs-navigation-overlay-handle fs-navigation-overlay-left-handle fs-navigation-handle__0 fs-navigation__0 fs-swap-element fs-touch-element"
            data-swap-target=".fs-navigation__0"
            data-swap-linked="fs-navigation-handle__0"
            data-swap-group="fs-navigation"
            onClick={handeleButton}
          ></div>
        </div>
        <div id="navbar" className="navbar--nav">
          <ul
            className="hidden-xs hidden-sm navbar__links first-li"
            style={{ flexShrink: 0 }}
          >
            <li style={{ whiteSpace: "nowrap", flexShrink: 0 }}>
              <div id="openHowItWorks" className="dropdown">
                <a
                  id="how_it_works"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                  className="navbar__links__link"
                  href="#"
                  onClick={handleOpenHowItWork}
                  role="button"
                  style={{ whiteSpace: "nowrap" }}
                >
                  {t("navbar.how-it-work")}
                </a>
                <ul className="dropdown-menu" aria-labelledby="how_it_works">
                  <li>
                    <Link to="/digital-signature" target="_blank" rel="noopener noreferrer">
                      {t("navbar.features")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/features-for-teams">
                      {t("navbar.features-for-teams")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/compliance">{t("navbar.compliance")}</Link>
                  </li>
                </ul>
              </div>
            </li>
            <li style={{ whiteSpace: "nowrap", flexShrink: 0 }}>
              <Link
                className="navbar__links__link"
                to="/pricing/portal"
                style={{ whiteSpace: "nowrap" }}
              >
                {t("navbar.pricing")}
              </Link>
            </li>
            <li style={{ whiteSpace: "nowrap", flexShrink: 0 }}>
              <Link
                className="navbar__links__link"
                to="/solutions"
                style={{ whiteSpace: "nowrap" }}
              >
                {t("navbar.api-solutions")}
              </Link>
            </li>
            {/* <li>
              <div id="resource" className="dropdown">
                <a
                  id="resource"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                  className="navbar__links__link"
                  href="#"
                  onClick={handleOpenResource}
                  role="button"
                >
                  {t("navbar.resource")}
                </a>
                <ul className="dropdown-menu" aria-labelledby="resource">
                  <li>
                    <a href="/documentation">{t("navbar.document")}</a>
                  </li>
                  <li>
                    <a href="/eids">{t("navbar.eids")}</a>
                  </li>
                  
                </ul>
              </div>
            </li> */}
            <li style={{ whiteSpace: "nowrap", flexShrink: 0 }}>
              <div id="openCompany" className="dropdown">
                <a
                  id="company"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                  className="navbar__links__link"
                  href="#"
                  onClick={handleOpenCompany}
                  role="button"
                  style={{ whiteSpace: "nowrap" }}
                >
                  {t("navbar.company")}
                </a>
                <ul className="dropdown-menu" aria-labelledby="company">
                  <li>
                    <Link to="/about-us">{t("navbar.about-us")}</Link>
                  </li>
                  {/* <li><Link to="/careers">{t('navbar.careers')}</Link></li> */}
                  <li>
                    <Link to="/contacts">{t("navbar.contacts")}</Link>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          {/* <ul className="hidden-xs hidden-sm navbar__links navbar__links--right">
            <li>
              <button className="btn-yellow-small !pb-3 !h-auto">
                {t("navbar.get-started")}
              </button>
            </li>
          </ul> */}
          <ul
            className="hidden-xs hidden-sm navbar__links navbar__links--right"
            style={{ flexShrink: 0 }}
          >
            <li style={{ whiteSpace: "nowrap", flexShrink: 0 }}>
              <Link
                className="navbar__links__link"
                to={`https://gopaperless.mobile-id.vn/workflow/portal/login?language=${
                  i18n.language || "vi"
                }`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ whiteSpace: "nowrap" }}
              >
                {t("navbar.login")}
              </Link>
            </li>

            <Link
              className="btn-yellow-small mt-22 mt-md-29"
              to={`https://gopaperless.mobile-id.vn/workflow/portal/login?language=${
                i18n.language || "vi"
              }`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ whiteSpace: "nowrap", flexShrink: 0 }}
            >
              {t("navbar.get-started")}
            </Link>
              <li
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexShrink: 0,
              }}
            >
              <div id="openDropupMenuBottom" className="dropdown drop-up">
                <a
                  id="dropupMenuBottom"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                  className="navbar__links__link_language"
                  href="#"
                  onClick={handleOpenMenuBottom}
                  role="button"
                >
                  {i18n.language === "en" ? (
                    <div className="flex mw-105" >
                      <img src={en8} alt="en8" />

                      <i className="fa fa-angle-down"></i>
                    </div>
                  ) : (
                    <div className="flex mw-105" >
                      <img src={vn8} alt="vn8" />

                      <i className="fa fa-angle-down"></i>
                    </div>
                  )}
                </a>
                <ul
                style={{borderRadius:"8px"}}
                  className="dropdown-menu change-language-dropdown"
                  aria-labelledby="dropupMenuBottom"
                >
                  <li className="mb-5">
                    <div className="flex">
                      <a
                        href="#"
                        style={{textDecoration:"none", paddingTop:"5px", paddingBottom:"5px", paddingLeft:"10px", paddingRight:"10px"}}
                        className="font-14"
                        onClick={(e) => {
                          e.preventDefault();
                          handleChangeLanguage("en");
                        }}
                      >
                        <img src={en8} alt="en8" />
                        <span className="pt-4 ml-5">English</span>
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="flex">
                      <a
                        href="#"
                        style={{textDecoration:"none", paddingTop:"5px", paddingBottom:"5px", paddingLeft:"10px", paddingRight:"10px"}}
                        className="font-14"
                        onClick={(e) => {
                          e.preventDefault();
                          handleChangeLanguage("vi");
                        }}
                      >
                        <img src={vn8} alt="vn8" />
                        <span className="pt-4 ml-5">Tiếng Việt</span>
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </li>
          </ul>

          <ul
            id="menuReponsiveLeft"
            data-navigation-handle="#handle"
            data-navigation-content="#content"
            className="mobile-nav navbar-nav navbar__links--mobile fs-navigation-element fs-navigation-overlay-nav fs-navigation-overlay-left-nav fs-navigation__0 fs-navigation-enabled fs-navigation-animated  "
          >
            <li className="pt-21 pb-3">
              <a className="navbar-brand-mobile gopaper-p" href="/">
                <img alt="GoPaperless" data-no-retina src={logo_gopaperless} />
              </a>
            </li>
            <hr className="mt-18" />
            <li>
              <Link className="navbar__links__link" to="/digital-signature" target="_blank" rel="noopener noreferrer">
                {t("navbar.features")}
              </Link>
            </li>
            <li>
              <Link className="navbar__links__link" to="/features-for-teams">
                {t("navbar.features-for-teams")}
              </Link>
            </li>
            <li>
              <Link className="navbar__links__link" to="/compliance">
                {t("navbar.compliance")}
              </Link>
            </li>
            <li>
              <Link className="navbar__links__link" to="/pricing/portal">
                {t("navbar.pricing")}
              </Link>
            </li>
            <li>
              <Link className="navbar__links__link" to="/solutions">
                {t("navbar.api-solutions")}
              </Link>
            </li>
            {/* <li>
              <a className="navbar__links__link" href="/documentation">
                {t("navbar.document")}
              </a>
            </li>
            <li>
              <a className="navbar__links__link" href="/eids">
                {t("navbar.eids")}
              </a>
            </li> */}
            {/* <li>
              <a className="navbar__links__link" href="/customer-stories">
                {t("navbar.customer")}
              </a>
            </li> */}
            <li>
              <Link className="navbar__links__link" to="/about-us">
                {t("navbar.about-us")}
              </Link>
            </li>
            {/* <li>
              <a
                className="navbar__links__link"
                href="/solutions/signature-collection"
              >
                {t("navbar.signature-collection")}
              </a>
            </li>
            <li>
              <a
                className="navbar__links__link"
                href="/solutions/e-signing-api"
              >
                {t("navbar.signing")}
              </a>
            </li>
            <li>
              <a
                className="navbar__links__link"
                href="/solutions/e-identification-api"
              >
                {t("navbar.identification")}
              </a>
            </li>
            <li>
              <a
                className="navbar__links__link"
                href="/solutions/e-sealing-api"
              >
                {t("navbar.sealing")}
              </a>
            </li> */}
            {/* <li ><a className="navbar__links__link" href="javascript:;">{t('navbar.careers')}</a></li> */}
            <li>
              <Link className="navbar__links__link" to="/contacts">
                {t("navbar.contacts")}
              </Link>
            </li>
            <hr />
            <li>
              <ul className="list list-inline navbar__links--list-language">
                <li className={i18n.language === "en" ? "active" : ""}>
                  <a
                    href="#"
                    onClick={() => {
                      i18n.changeLanguage("en");
                      handleChangeLanguage("en");
                    }}
                    id="enLanguageSidebar"
                    className="active"
                  >
                    EN
                  </a>
                </li>
                <li className={i18n.language === "vi" ? "active" : ""}>
                  <a
                    href="#"
                    onClick={() => {
                      i18n.changeLanguage("vi");
                      handleChangeLanguage("vi");
                    }}
                    id="viLanguageSidebar"
                    className=""
                  >
                    VI
                  </a>
                </li>
              </ul>
            </li>
            <hr />
            <li>
              <a
                className="navbar__links__link"
                href={`https://gopaperless.mobile-id.vn/workflow/portal/login?language=${
                  i18n.language || "vi"
                }`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("navbar.login")}
              </a>
            </li>
            <li>
              <a
                className="navbar__links__link button-start-free-nav"
                id="button-start-free-en"
                href={`https://gopaperless.mobile-id.vn/workflow/portal/login?language=${
                  i18n.language || "vi"
                }`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("navbar.get-started")}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavbarTop;